// extracted by mini-css-extract-plugin
export default {"addToCartControl":"C1-z","giftCard":"D1-z","btnContainer":"E1-z","cartButton":"F1-z","disabled":"G1-z"};